<template>
  <div class="overlay-header-parts" :class="`overlay-header-parts--${screenOrientationType}`">
    <div class="overlay-header-parts__inner">
      <router-link
        v-if="!screenLandScape || lockOrientation !== undefined"
        class="overlay-header-parts__back-button"
        to=""
        @click.native="historyBack"
      >
        <img :src="require('@/assets/img/icon/icon_chevron_left_24__white.svg')" alt="<" />
      </router-link>

      <h2 class="overlay-header-parts__title">{{ videoTitle }}</h2>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType } from '@vue/composition-api'
import VueRouter from 'vue-router'
import { LockOrientationType } from '@/views/RaceVideoPage/RaceVideoPage.vue'

/**
 * レース動画再生画面 動画プレーヤー オーバーレイヘッダーコンポーネント
 */
export default defineComponent({
  name: 'OverlayHeaderParts',
  inject: ['router'],
  props: {
    /**
     * 動画タイトル
     */
    videoTitle: {
      type: String,
      required: true,
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 画面固定
     */
    lockOrientation: {
      type: String as PropType<LockOrientationType>,
    },
  },
  setup(props) {
    const router = inject('router') as VueRouter

    const screenLandScape = computed(() => props.screenOrientationType?.indexOf('landscape') !== -1)
    const queryKeys = Object.keys(router.currentRoute.query)

    // レース一覧画面に戻すべきかどうか
    const backToTop = router.currentRoute.query.backToTop === 'true'

    return {
      screenLandScape,
      queryKeys,
      backToTop,
    }
  },
  methods: {
    historyBack() {
      if (this.backToTop) {
        // レース一覧画面に戻す
        this.$router.replace({ name: 'TopPage' })
        return
      }
      if (this.queryKeys.length > 0) {
        /**
         * NOTE: クエリパラメータが付いている場合、this.$router.go(-1)とすると1つ前の画面に戻れなかった
         * this.$router.go(-2)とすると1つ前の画面に戻れたので、以下のように記載している
         */
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.overlay-header-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  color: $white;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 90%) 100%);

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 6px 8px;
  }

  &__title {
    width: calc(100% - 44px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
  }

  &__back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-right: 8px;
    font-size: 13px;
    font-weight: 600;
  }

  &--landscape-primary,
  &--landscape-secondary {
    justify-content: center;

    .overlay-header-parts {
      &__inner {
        justify-content: space-between;
        max-width: 724px;
        padding: 6px 12px;
        height: 48px;
      }

      &__title {
        font-size: 14px;
      }
    }
  }
}
</style>
